import { Component, Input, Output, EventEmitter, OnChanges, ViewEncapsulation, ViewChild } from '@angular/core';
import { FileRestrictions, UploadComponent, UploadEvent } from '@progress/kendo-angular-upload';
import { UploadFile } from '../../models/attachment/upload-file';
import { OnInit, SimpleChanges } from '@angular/core/src/metadata/lifecycle_hooks';
import { DomSanitizer } from '@angular/platform-browser';
import { DialogService } from '@progress/kendo-angular-dialog';
import { ImagePopup } from '../image-popup/image-popup.component';
import { AppService } from '../../../app.service';
import { KeyValueObject } from '../../models/core/KeyValueObject';
import { LookupService } from '../../services/lookup.service';
import { NotificationService } from '../../../core/services/notification.service';
import { NotificationType } from '../../../core/services/notification-type';
import { AttachmentsService } from '../../services/attachments.service';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { DataSourceRequestState } from '@progress/kendo-data-query/dist/npm/mvc/operators';
import { DOC_ORIENTATION, NgxImageCompressService } from 'ngx-image-compress';
@Component({
	selector: 'upload-attachments',
	templateUrl: './upload-attachments.component.html',
	styleUrls: [
		'../../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
		'./upload-attachments.component.scss'
	],
	encapsulation: ViewEncapsulation.None
})
export class UploadAttachmentsComponent implements OnInit, OnChanges {
	canUpload = false;

	@Input() showUploadButton = false;
	@Input() allowedExtensions: string[] = [];
	@Input() uploadPercentages?: number;
	@Input() selectName?: string = null;
	@Input() isSingleSelectFileType: boolean = false;
	@Input() visibleAttachmentTypes: number[] = [];
	@Input() showAttachmentTypes: boolean = true;
	@Input() customAttachmentTypes: KeyValueObject[] = []
	@Output() isCompressingEvent : EventEmitter<boolean> = new EventEmitter();

	@ViewChild("uploader") uploader: UploadComponent;

	uploadFiles: UploadFile[] = [];

	@Output() onUploadFilesAdded: EventEmitter<UploadFile[]> = new EventEmitter<UploadFile[]>();

	public extensionRestrictions: FileRestrictions = {};

	
	imageExtensions: string[] = ['.png', '.jpg', '.jpeg'];
	pngExtension: string = '.png';

	qualityCompression = 50;
	resolutionCompression = 50;

	fileSizeLimitKBytes: number = 2000;
	compressInProgressFileIds: string[] = [];
	attachmentTypes: KeyValueObject[] = [];

	public dropDownFilterSettings: DropDownFilterSettings = { caseSensitive: false, operator: 'contains' };

	constructor(
		private sanitizer: DomSanitizer,
		private imageCompress: NgxImageCompressService,
		protected dialogService: DialogService,
		protected notificationService: NotificationService,
		private appService: AppService,
		private lookupService: LookupService,
		private attachmentsService: AttachmentsService
	) {
	}

	ngOnInit(): void {
		if (!!this.visibleAttachmentTypes && this.visibleAttachmentTypes.length > 0) {

			let attachmentTypesFilters = [];

			this.visibleAttachmentTypes.forEach(f => {
				attachmentTypesFilters.push({ field: 'AttachmentTypeId', operator: 'eq', value: f });
			});

			const attachmentTypesState: DataSourceRequestState = {
				filter: {
					logic: 'or', filters: attachmentTypesFilters
				}
			};

			this.lookupService.getData("attachment-types", attachmentTypesState).subscribe(data => {
				this.attachmentTypes = data;
				if(this.customAttachmentTypes.length > 0){
					this.attachmentTypes = this.attachmentTypes.concat(this.customAttachmentTypes);
				}
				this.applyDefaultAttachmentTypeToUploadFiles();
			});
		} else {
			this.lookupService.getData("attachment-types", null).subscribe(data => {
				this.attachmentTypes = data.filter(x => x.id > 2);
				if(this.customAttachmentTypes.length > 0){
					this.attachmentTypes = this.attachmentTypes.concat(this.customAttachmentTypes);
				}
				this.applyDefaultAttachmentTypeToUploadFiles();
			});
		}	
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.allowedExtensions && changes.allowedExtensions.currentValue) {
			this.extensionRestrictions.allowedExtensions = changes.allowedExtensions.currentValue;
		}
	}

	get getSelectName(): string {
		if (this.selectName === null) {
			return "Добавить файлы";
		} else {
			return this.selectName;
		}
	}

	get getLoadName(): string {
		if(this.isCompressing){
			return "Сжатие...";
		}
			return "Загрузить";
	}

	openPreview(file: UploadFile) {

		if (!this.isImageExtension(file.fileExtension) || file.fileSize > this.fileSizeLimitKBytes * 1024)
			return;

		const dialogRef = this.dialogService.open({ content: ImagePopup, width: this.appService.isMobileDevice ? '90%' : '90%', height: '90%' });

		const imagePopup = <ImagePopup>dialogRef.content.instance;

		imagePopup.src = this.getImageUrl(file);
	}

	getImageUrl(file: UploadFile) {
		return `data:image/png;base64,${file.fileData}`
	}

	async uploadEventHandler(e: UploadEvent, uploader) {

		let filesToCompress = [];
		let promises = [];
		const files = e.files;

		files.forEach(file => {
			if (file) {
				promises.push(new Promise((resolve, reject) => {
					try{
						const reader = new FileReader();
						const self = this;
						reader.onloadend = function (readerEvt: any) {
							const binaryString = <string>readerEvt.target.result;
	
							const uploadFile = new UploadFile();
							uploadFile.uid = file.uid;
							uploadFile.fileName = file.name;
							uploadFile.fileExtension = file.extension;
							uploadFile.fileData = btoa(binaryString);
							uploadFile.fileSize = file.size;
							self.applyDefaultAttachmentType(uploadFile);
	
							self.uploadFiles.push(uploadFile);
	
							if ((uploadFile.fileSize > self.fileSizeLimitKBytes * 1024) && self.isImageExtension(uploadFile.fileExtension)){
								filesToCompress.push(uploadFile);
							}
	
							if (!self.showUploadButton) {
								self.onUploadFilesAdded.emit(self.uploadFiles);
							}
	
							resolve(reader.result);
						};
						
						reader.readAsBinaryString(file.rawFile);
					}
					catch(ex){
						this.notificationService.warning({
							title: 'Ошибка при добавлении файла',
							message: `Ошибка при добавлении файла ${file.name}`,
							notificationType: NotificationType.SweetAlert,
						});
						reject();
					}
				}));				
			}
		});	

		await Promise.all(promises);
		this.compressFiles(uploader, filesToCompress);
	}

	removeEventHandler(event: any): void {
		this.uploadFiles = this.uploadFiles.filter(x => x.uid !== event.files[0].uid);
	}

	private applyDefaultAttachmentTypeToUploadFiles(): void {
		this.uploadFiles.forEach(file => this.applyDefaultAttachmentType(file));
	}

	private applyDefaultAttachmentType(file: UploadFile): void {
		if (this.attachmentTypes.length === 1 && file.attachmentTypeIds.length === 0) {
			file.attachmentTypeId = this.attachmentTypes[0].id;
		}
	}

	get isCompressing(): boolean {
		let compressing = this.compressInProgressFileIds.length > 0;
		return compressing;
	}
	

	upload(uploader: any) {

		if (this.uploadFiles.length > 0 && this.uploadFiles.some(x => x.attachmentTypeIds.length === 0)) {
			this.notificationService.error({
				title: 'Ошибка',
				message: "Укажите типы для загружаемых файлов",
				notificationType: NotificationType.SweetAlert
			});

			return;
		}

		this.onUploadFilesAdded.emit(this.uploadFiles);
		uploader.clearFiles();
		this.uploadFiles = [];
	}

	successUploadedEventHandler(e: any) {
		this.canUpload = true;
	}

	public removeFile(uploader, uid: string) {
		uploader.removeFilesByUid(uid);
		this.uploadFiles = this.uploadFiles.filter(x => x.uid !== uid);

		if (!this.showUploadButton) {
			this.onUploadFilesAdded.emit(this.uploadFiles);
		}
	}

	isImageExtension(extension: string): boolean {

		if (extension == null)
			return false;


		extension = extension.toLowerCase();

		return this.imageExtensions.some(ext => extension === ext);
	}

	getByFileImageClassByExtension(extension: string): string {

		var imageClass = "fa-file";

		switch (extension) {
			case ".xls":
			case ".xlsx":
				imageClass = "fa-file-excel";
				break;
			case ".doc":
			case ".docx":
				imageClass = "fa-file-word";
				break;
			case ".pdf":
				imageClass = "fa-file-pdf";
				break;
			case ".zip":
			case ".rar":
				imageClass = "fa-file-archive";
				break;
			case ".ppt":
			case ".pptx":
				imageClass = "fa-file-powerpoint";
				break;
		}

		return imageClass;
	}

	compressFiles(uploader, files: UploadFile[]){
		if (files.length == 0)
			return;

		this.isCompressingEvent.emit(true);

		files.forEach(fileToCompress => {
			this.compressInProgressFileIds.push(fileToCompress.uid);
			if (this.isMobileDevice){
				this.compressLocally(uploader, fileToCompress);
			} else {
				this.compressOnServer(uploader, fileToCompress);
			}
		})
	}

	compressOnServer(uploader, file: UploadFile){	
		this.attachmentsService.compressAttachment(file.fileName, file.fileData).subscribe(x => {
			file.fileName = x.data.fileName;
			file.fileData = x.data.fileData;
			file.fileSize = x.data.fileSizeBytes;

			const index = this.compressInProgressFileIds.indexOf(file.uid, 0);
			if (index > -1) {
				this.compressInProgressFileIds.splice(index, 1);
			}

			if (this.compressInProgressFileIds.length == 0){
				this.isCompressingEvent.emit(false);
			}

			if (file.fileSize > this.fileSizeLimitKBytes * 1024){

				this.notificationService.warning({
					title: 'Сжатие',
					message: `Размер файла ${file.fileName} после сжатия ${(file.fileSize / 1024).toFixed(2)} Кб, что не укладывается в максимально допустимый размер ${this.fileSizeLimitKBytes} Кб. Файл будет удален из очереди загрузки`,
					notificationType: NotificationType.SweetAlert,
				});

				this.removeFile(uploader, file.uid);
			}
		});

	}

	compressLocally(uploader, file: UploadFile){
		let docType: DOC_ORIENTATION;
		let imageToCompress: string;

		if (this.isPng(file.fileExtension)){
			imageToCompress = `data:image/png;base64,${file.fileData}`;
			docType = DOC_ORIENTATION.NotDefined;
		} else {
			imageToCompress = `data:image/jpeg;base64,${file.fileData}`;
			docType = DOC_ORIENTATION.Up;
		}	

		this.imageCompress.compressFile(imageToCompress, docType, this.resolutionCompression, this.qualityCompression).then(
			result => {
				let imageeWithoutBase64 = result.replace(/^data:image\/[a-z]+;base64,/, "");

				file.fileData = imageeWithoutBase64;
				file.fileSize = this.imageCompress.byteCount(imageeWithoutBase64);

				const index = this.compressInProgressFileIds.indexOf(file.uid, 0);
				if (index > -1) {
					this.compressInProgressFileIds.splice(index, 1);
				}
				if (this.compressInProgressFileIds.length == 0){
					this.isCompressingEvent.emit(false);
				}

				if (file.fileSize > this.fileSizeLimitKBytes * 1024){

					this.notificationService.warning({
						title: 'Сжатие',
						message: `Размер файла после сжатия ${(file.fileSize / 1024).toFixed(2)} Кб, что не укладывается в максимально допустимый размер ${this.fileSizeLimitKBytes} Кб. Файл будет удален из очереди загрузки`,
						notificationType: NotificationType.SweetAlert,
					});

					this.removeFile(uploader, file.uid);
				}
			}
		);
	}

	isPng(extension: string){

		if (extension == null)
			return false;

		if (extension === this.pngExtension){
			return true;
		}
		return false;
	}

	get isMobileDevice(): boolean {
		return this.appService.isMobileDevice;
	}

}
